import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import styles from './RejectLeaveRequest.module.css';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const RejectLeaveRequest = ({ open, onClose, onConfirm, request }) => {
  const [remark, setRemark] = useState('');
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [error, setError] = useState(null);

  console.log('request in transfer reject modal', request);
  useEffect(() => {
    if (request) {
      setSelectedRequest(request);
    }
  }, [request]);

  useEffect(() => {
    if (request) {
      setSelectedRequest(request);
    }
  }, [request]);

  if (!open) return null;

 const handleReject = async () => {
  try {
    if (!remark) {
      toast.error('Remark cannot be empty.');
      return;
    }

    // API call to reject gate pass request
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/gate_pass/gatepasses/${selectedRequest._id}/status`,
      {
        method: 'PATCH', // PUT since it's updating status
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('Token')}`,
        },
        body: JSON.stringify({
          status: 'Rejected',
          remark: remark || 'Rejected by Warden', // use provided remark or default
        }),
      }
    );

    if (!response.ok) {
      throw new Error('Failed to reject gate pass request');
    }

    toast.success('Gate pass request rejected successfully.');
    onConfirm && onConfirm(); // callback to parent
    onClose();
    setRemark('');
  } catch (err) {
    console.error('Error rejecting gate pass request:', err);
    toast.error('Failed to reject gate pass request');
  }
};


  return (
    <Box className={styles.rejectModal} onClick={onClose}>
      <Box className={styles.rejectModalContent} onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <Box className={styles.rejectModalHeader}>
          <Typography className={styles.rejectModalTitle}>Reject  {request?.requestType} Request</Typography>
          <IconButton
            className={styles.rejectCloseButton}
            onClick={() => {
              onClose();
              setRemark('');
            }}
          >
            <Close />
          </IconButton>
        </Box>

        {/* Modal Content */}
        <Box className={styles.rejectModalBody}>
          <Typography className={styles.rejectConfirmationText}>Are you sure you want to reject this leave request?</Typography>

          <Typography className={styles.rejectWarningText}>This action cannot be undone</Typography>

          <Box className={styles.rejectRemarkSection}>
            <Typography className={styles.rejectRemarkLabel}>Remark</Typography>
            <textarea
              id="remark"
              name="remark"
              placeholder="Enter remark"
              className={styles.rejectRemarkTextarea}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Box>
        </Box>

        {/* Modal Footer */}
        <Box className={styles.rejectModalFooter}>
          <Button className={styles.rejectCancelButton} onClick={onClose}>
            Cancel
          </Button>
          <Button className={styles.rejectConfirmButton} onClick={handleReject}>
            Yes, Reject
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default RejectLeaveRequest;
